import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { EntityRepository, Repository } from "typeorm";
import { ApplyForLeaves } from "../apply-for-leaves.entity";
import { GetAllAvailableLeavesDto } from "../dto/get-available-leaves.dto";

@EntityRepository(ApplyForLeaves)
export class ApplyForLeavesRepository extends Repository<ApplyForLeaves> {
    async getAllConsumedLeaves(req: GetAllAvailableLeavesDto): Promise<number> {
        const leavesConsumed: any = await this.createQueryBuilder("ApplyForLeaves")
            .select('COALESCE(SUM(no_of_days),0) AS leaves_consumed')
            .where(`employee_id=${req.employeeId} AND type_of_leave='${req.typeOfLeave}'  AND STATUS='${LeaveApprovalStatusEnum.APPROVED}' `)
            .getRawOne();
            console.log(leavesConsumed);
        return leavesConsumed.leaves_consumed;
    }

    async getAllConsumedLeavesByLeaveTypeAndEmpId(empId: number, year: string, leaveType: number): Promise<number> {
        const leavesConsumed: any = await this.createQueryBuilder("ApplyForLeaves")
            .select('COALESCE(SUM(no_of_days),0) AS leaves_consumed')
            .where(`employee_id=${empId} AND type_of_leave='${leaveType}' AND YEAR(to_date)=${year}  AND STATUS='${LeaveApprovalStatusEnum.APPROVED}' `)
            .getRawOne();
        return leavesConsumed.leaves_consumed;
    }

    async getRejectionReason(id:number): Promise<any[]> {
        const query = this.createQueryBuilder('apply-for-leaves')
        .select("apply-for-leaves.employee_id,employee_details.mobile_no,apply-for-leaves.employee_code,apply-for-leaves.rejection_reason,employee_details.employee_name")
        .leftJoin('employee_details','ed','ed.employee_id =apply-for-leaves.employee_id ')
        .where(`apply-for-leaves.employee_id ='${id}'`)
        return await query.getRawMany();
    }  

}